import { Component, isDevMode } from '@angular/core';
import { MenuService } from './menu.service';

import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '@wephone-core/service/authentication';
import { Router } from '@angular/router';
import { PhoneService } from '@wephone-app-phone/services';
import { DialogService } from '@wephone-utils';
import { TestHeadsetModalComponent } from '@wephone-app-phone/modals/test-headset-modal/test-headset-modal.component';
import { ElectronService } from 'ngx-electron';
import { EnterpriseContactsModalComponent } from '@wephone-app-phone/modals/enterprise-contacts-modal/enterprise-contacts-modal';
import { IPPhoneProvisioningModal } from '@wephone-app-phone/modals/ipphone-provisioning/ipphone-provisioning';
import { IssueReportModalComponent } from '@wephone-app-phone/modals/issue-report/issue-report-modal.component';
import { LiveTrackingModalComponent } from '@wephone-app-phone/modals/live-tracking-modal/live-tracking-modal';
import { EnterpriseEntity } from '@wephone-core/model/entity/enterprise';
import { EnterpriseRepository } from '@wephone-core/model/repository/enterprise';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  providers: [MenuService]
})
export class MenuComponent {
  // currentLang = 'en';
  devMode: boolean = isDevMode();
  myEnterprise: EnterpriseEntity;

  constructor(
    public menuService: MenuService,
    public translate: TranslateService,
    private readonly authService: AuthenticationService,
    private readonly router: Router,
    public phoneService: PhoneService,
    public dialogService: DialogService,
    protected electronService: ElectronService,
  ) {
    this.myEnterprise = EnterpriseRepository.getInstance<EnterpriseRepository>().getMyEnterprise();
  }

  isAdmin(): boolean {
    return this.authService.isAdmin();
  }

  addMenuItem(): void {
    this.menuService.add({
      state: 'menu',
      name: 'MENU',
      type: 'sub',
      icon: 'trending_flat',
      children: [{ state: 'menu', name: 'MENU' }, { state: 'timeline', name: 'MENU' }]
    });
  }

  async logout(): Promise<void> {
    await this.authService.logout();
    /*
    this.router.navigate(['/', 'session', 'signin'], {
      queryParams: { returnUrl: '/' }
    });
    */
    // window.location.reload(false);
  }

  checkHeadset(): any {
    return this.dialogService.openDialog2(TestHeadsetModalComponent, {});
  }

  openLiveTracking(): any {
    return this.dialogService.openDialog2(LiveTrackingModalComponent, { size: 'fs' });
  }

  openEnterpriseContact(): void {
    this.dialogService.openDialog2(EnterpriseContactsModalComponent, { size: 'fs', padding: false });
  }

  openIPPhonePrivisioningDialog(): any {
    return this.dialogService.openDialog2(IPPhoneProvisioningModal, {});

  }
  // agentSentSms(): any {
  //   return this.dialogService.openDialog2(SentSmsModalComponent, {});
  // }

  isElectronApp(): any {
    return this.electronService.isElectronApp;
  }

  quit(): void {
    if (this.isElectronApp()) {
      window['EREMOTE'].app.exit();
    }
  }

  issueReport(): void {
    this.dialogService.openDialog2(IssueReportModalComponent, { data: { call_id: undefined }, size: 's' });
  }
}
